<template>
    <v-container fluid class="pa-0 ma-0" @click.stop>
        <v-row no-gutters class="pl-2 my-1">
            <v-col cols="12" class="my-2" v-if="divider">
                <v-divider style="width: 100%" />
            </v-col>
            <v-col v-if="title" cols="12" class="my-2">
                <span>{{ title }}</span>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'hidden') && isUsed('hidden')"
                :cols="col"
                class="px-2 py-2"
            >
                <v-checkbox
                    v-model="styleObj.hidden"
                    label="Cacher le bloc"
                    class="mt-0"
                    :disabled="disabledHidden"
                >
                </v-checkbox>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'boxHeight') && isUsed('boxHeight')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.boxHeight"
                    label="Hauteur de la boite"
                    :step="0.5"
                    :min="0"
                    :max="internalMaxValues.boxHeight"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                    data-cy="AdvancedBoxEditor-hauteurDeLaBoite"
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'boxWidth') && isUsed('boxWidth')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.boxWidth"
                    label="Largeur de la boite"
                    :step="0.5"
                    :min="0"
                    :max="internalMaxValues.boxWidth"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                    data-cy="AdvancedBoxEditor-largeurDeLaBoite"
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'padding') && isUsed('padding')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.padding"
                    label="Marges intérieures"
                    :step="0.5"
                    :min="0"
                    :max="internalMaxValues.padding"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                    data-cy="AdvancedBoxEditor-margesInferieures"
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'leftMargin') && isUsed('leftMargin')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.leftMargin"
                    label="Marge gauche"
                    :step="0.5"
                    :max="internalMaxValues.leftMargin"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'rightMargin') && isUsed('rightMargin')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.rightMargin"
                    label="Marge droite"
                    :step="0.5"
                    :max="internalMaxValues.rightMargin"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'topMargin') && isUsed('topMargin')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.topMargin"
                    label="Marge supérieure"
                    :step="0.5"
                    :max="internalMaxValues.topMargin"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'bottomMargin') && isUsed('bottomMargin')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.bottomMargin"
                    label="Marge inférieure"
                    :step="0.5"
                    :max="internalMaxValues.bottomMargin"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append-outer>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col :cols="12" class="pa-0 ma-0" />
            <v-col
                v-if="hasAttr(styleObj, 'border') && isUsed('border')"
                :cols="col"
                class="px-2 py-2"
            >
                <v-checkbox
                    v-model="styleObj.border"
                    color="primary"
                    label="Bordures"
                    class="mt-0"
                    density="compact"
                    :disabled="internalDisabled"
                    data-cy="AdvancedBoxEditor-bordures"
                >
                </v-checkbox>
            </v-col>
            <v-col
                v-if="
                    hasAttr(styleObj, 'borderColor') &&
                    hasAttr(styleObj, 'border') &&
                    isUsed('borderColor')
                "
                :cols="col"
                class="px-2 py-2"
            >
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ props }">
                        <VTextFieldFilled
                            v-model="borderColor"
                            v-bind="props"
                            label="Bordures"
                            readonly
                            hide-details
                            :disabled="!styleObj.border || disabled"
                            density="compact"
                        >
                            <template v-slot:prepend-inner>
                                <div
                                    class="d-flex align-self-center"
                                    :style="colorIconStyle(borderColor)"
                                />
                            </template>
                        </VTextFieldFilled>
                    </template>
                    <v-color-picker
                        v-model="borderColor"
                        show-swatches
                        mode="hexa"
                        hide-mode-switch
                        :swatches="swatches"
                        :disabled="internalDisabled"
                    >
                    </v-color-picker>
                </v-menu>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'borderRadius') && isUsed('borderRadius')"
                :cols="col"
                class="px-2 py-2"
            >
                <CustomNumberField
                    v-model="styleObj.borderRadius"
                    label="Arrondi des bordures"
                    :step="0.5"
                    :max="internalMaxValues.borderRadius"
                    placeholder="Auto"
                    :disabled="internalDisabled"
                    hide-details
                    data-cy="InvoiceThemeMenu-arrondiDesBordures"
                >
                    <template #pre-append>
                        <div style="font-size: small; height: fit-content; margin: auto">mm</div>
                    </template>
                    <!-- <template #append>
                        <span class="text-small">mm</span>
                    </template> -->
                </CustomNumberField>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'backgroundColor') && isUsed('backgroundColor')"
                :cols="col"
                class="px-2 py-2"
            >
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ props }">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <VTextFieldFilled
                                    v-model="bgColor"
                                    v-bind="props"
                                    label="Couleur de fond"
                                    density="compact"
                                    readonly
                                    hide-details
                                    :disabled="internalDisabled"
                                    data-cy="AdvancedBoxEditor-couleurDeFond"
                                >
                                    <template v-slot:prepend-inner>
                                        <div
                                            class="d-flex align-self-center"
                                            :style="colorIconStyle(bgColor)"
                                        />
                                    </template>
                                </VTextFieldFilled>
                            </v-col>
                        </v-row>
                    </template>
                    <v-color-picker
                        v-model="bgColor"
                        show-swatches
                        mode="hexa"
                        hide-mode-switch
                        :swatches="swatches"
                        :disabled="internalDisabled"
                        data-cy="AdvancedBoxEditor-couleur"
                    >
                    </v-color-picker>
                </v-menu>
            </v-col>
            <v-col
                v-if="hasAttr(styleObj, 'color') && isUsed('color')"
                :cols="col"
                class="px-2 py-2"
            >
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ props }">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <VTextFieldFilled
                                    v-model="textColor"
                                    v-bind="props"
                                    label="Couleur du texte"
                                    readonly
                                    hide-details
                                    :disabled="internalDisabled"
                                    density="compact"
                                >
                                    <template v-slot:prepend-inner>
                                        <div
                                            class="d-flex align-self-center"
                                            :style="colorIconStyle(textColor)"
                                        />
                                    </template>
                                </VTextFieldFilled>
                            </v-col>
                        </v-row>
                    </template>
                    <v-color-picker
                        v-model="textColor"
                        show-swatches
                        mode="hexa"
                        hide-mode-switch
                        :swatches="textColorSwatches"
                        :disabled="internalDisabled"
                    >
                    </v-color-picker>
                </v-menu>
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import CustomNumberField from "./CustomNumberField.vue";
import InvoiceThemeService from "../../../../backend/src/common/invoiceTheme/invoiceThemeService";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        CustomNumberField,
    },
    emits: ["editing"],
})
export class AdvancedBoxEditor extends Vue {
    @Prop({ default: 2, type: [Number, undefined] }) perRow: number | undefined;
    @Prop({ default: null, type: String }) editedElementClass;

    @Model({ default: null }) styleObj;
    @Prop({ default: null, type: String }) title;
    @Prop({ default: () => []}) unusedOptions: string[];
    @Prop({ default: true, type: Boolean }) divider: boolean;
    @Prop({ default: false, type: Boolean }) disabled: boolean;
    @Prop({ default: false, type: Boolean }) disabledHidden: boolean;
    @Prop({ default: () => {} }) maxValues: any;

    get internalDisabled() {
        return this.disabled || this.styleObj?.hidden;
    }

    get internalMaxValues() {
        return this.maxValues ?? {};
    }

    swatches = [
        // ['#1abc9c','#2ecc71','#16a085','#95a5a6','#7f8c8d'],
        // ['#27ae60','#3498db','#2980b9','#c0392b','#ecf0f1'],
        // ['#9b59b6','#8e44ad','#34495e','#e67e22','#e74c3c'],
        // ['#2c3e50','#f1c40f','#f39c12','#d35400','#bdc3c7'],
        ["#b2e2f2ff", "#b0c2f2ff", "#84b6f4ff"],
        ["#77dd77ff", "#b0f2c2ff", "#d8f8e1ff"],
        ["#fcb7afff", "#fabfb7ff", "#ffe4e1ff"],
        ["#fdfd96ff", "#ffda9eff", "#fdf9c4ff"],
        ["#ffffffff", "#f5f5f5ff", "#efefefff"],
        ["#00000000"],
    ];

    textColorSwatches = [
        ["#000000FF", "#000000D9", "#00000099"],
        ["#FF0000FF", "#00FF00FF", "#0000FFFF"],
        ["#EEEEEEFF", "#333366FF", "#333333FF"],
        ["#FFFFFFFF", "#00658EFF", "#330066FF"],
        ["#FF00FFFF", "#00000066"],
    ];

    get col() {
        if (!this.perRow || this.perRow < 1) {
            return 6;
        }
        return Math.round(12 / Math.min(12, this.perRow));
    }

    @Watch("styleObj", { deep: true })
    editing() {
        if (this.editedElementClass) {
            this.$emit("editing", this.editedElementClass);
        }
    }

    @Watch("styleObj.borderRadius")
    updatePadding(newRadiusVal) {
        if (this.styleObj.padding != null) {
            debugger;
            const val = Math.max((newRadiusVal ?? 0) / 2, this.styleObj.padding ?? 0);
            this.styleObj.padding = val;
        }
    }

    colorIconStyle(bgColor) {
        return {
            height: "20px",
            width: "20px",
            "border-radius": "10px",
            "z-index": "1",
            "background-color": bgColor || "",
        };
    }

    hasAttr(obj: Object, attr: string) {
        if (obj) {
            return obj.hasOwnProperty(attr);
        }
        return false;
    }

    isUsed(key) {
        return !this.unusedOptions.includes(key);
    }

    get bgColor() {
        return InvoiceThemeService.formatColorToHexa(this.styleObj?.backgroundColor ?? "#FFFFFF00");
    }

    set bgColor(val) {
        if (this.styleObj?.backgroundColor) {
            this.styleObj.backgroundColor = val;
        }
    }

    get borderColor() {
        return InvoiceThemeService.formatColorToHexa(this.styleObj?.borderColor ?? "#FFFFFF00");
    }

    set borderColor(val) {
        if (this.styleObj?.borderColor) {
            this.styleObj.borderColor = val;
        }
    }

    get textColor() {
        if (!this.hasAttr(this.styleObj, "color")) {
            return null;
        }
        return InvoiceThemeService.formatColorToHexa(this.styleObj.color ?? "#000000FF");
    }

    set textColor(val) {
        // debugger
        if (this.hasAttr(this.styleObj, "color")) {
            this.styleObj.color = val;
        }
    }
}

export default toNative(AdvancedBoxEditor);
</script>
